import React from 'react';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import { List, ListItem } from '@material-ui/core';
import UseJoyride from './UseJoyride';

const DealsJoyride = () => {
  return (
    <Observer
      render={() => {
        const steps = [
          {
            title: 'Deals',
            target: '.dealsStep1',
            content:
              'This view is the detailing all of your organizations deals. Use this page to prioritize your punch list of items that need to be mapped.',
            disableBeacon: true,
            placement: 'top',
          },
          {
            title: 'Deals',
            target: '.rt-tr',
            content:
              'Sort by contract date, created by, AR Amount (accounts receivable), AR Mapped, AP Amount (accounts payable), AP Mapped, and status.',
          },
          {
            title: 'Deals',
            target: '.rt-tbody',
            content: 'Click on a transaction to view details of the deal.',
          },
        ];
        return (
          <UseJoyride passedSteps={steps} customProps={{ continuous: true }} />
        );
      }}
    />
  );
};

export default DealsJoyride;
